module.exports = __webpack_public_path__ + "media/images/rabas_logo-94b3e1be14fc8839740e3fc8a53639b2.png";